import React, { PureComponent } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Form, Input, Button, Row, Col, notification } from 'antd';
import { FormattedMessage } from "react-intl";
import { cw, hp } from "../../utils";

// import BrokenLink from '../../assets/img/card.svg';
import Esoko from '../../assets/img/auth/esoko.svg';
// import ResetSuccess from '../../assets/img/reset_success.svg';


class Reset extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            authType: 'msisdn', token: window.location.pathname.split('/')[3],
            validx: false, reseting: false, reseted: false
        };
    }

    componentDidMount() {
        const { _auth: { authenticated } } = this.props;
        if (authenticated) {
            window.location.assign(process.env.REACT_APP_SUCCESS_REDIRECT);
        }
    }

    asyncEmail = async (rule, value, callback) => {
        if (value) {
            return await axios({
                method: 'GET',
                url: `${hp.getApiBaseUrl()}/auth/validations/emails/${value.trim().toLowerCase()}`,
                json: true
            }).then((response) => {
                const res = response.data;
                if (res.statusCode === 200 && res.data.userExists === false) {
                    callback(`${value} does not exist`);
                } else {
                    callback();
                }
            }).catch(() => {
                callback(`${value} does not exist`);
            });
        } else {
            callback();
        }
    };
    confirmPasswordMatch = (rule, value, callback) => {
        if (!value) {
            callback();
        }
        if (value !== this.props.form.getFieldValue('password')) {
            callback('Passwords do not match');
        }
        callback();
    }

    _reset = e => {
        e.preventDefault();
        const { form: { validateFields }, } = this.props;
        validateFields((err, vals) => {
            if (!err) {
                this.setState({ reseting: true });
                axios({
                    method: 'POST',
                    url: `${hp.getApiBaseUrl()}/auth/password-reset-requests`,
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'Origin': window.location.origin
                    },
                    data: { email: vals.userName.trim().toLowerCase() }
                }).then((response) => {
                    this.setState({ reseting: false });
                    const res = response.data;
                    switch (res.statusCode) {
                        default:
                            notification.error({
                                message: this.props.intl.formatMessage(cw['Success']),
                                description: this.props.intl.formatMessage(cw['ResetPassword.Failed'])
                            });
                            break;
                        case 200:
                            this.setState({ reseted: true });
                            notification.success({
                                message: this.props.intl.formatMessage(cw['Success']),
                                description: this.props.intl.formatMessage(cw['ResetPassword.Success'])
                            });
                            window.location.assign(`/en/reset/${res.data.id}${window.location.search}`);
                            break;
                    }
                }).catch((err) => {
                    this.setState({ reseting: false });
                    notification.error({
                        message: this.props.intl.formatMessage(cw['Success']),
                        description: this.props.intl.formatMessage(cw['ResetPassword.Failed'])
                    });
                });
            }
        });
    };


    // ::: verify actions
    verifyResetToken = e => {
        e.preventDefault();
        const { token } = this.state;
        if (token) {
            const { form: { validateFields } } = this.props;
            validateFields((err, v) => {
                if (!err) {
                    this.setState({ reseting: true });
                    axios({
                        method: 'GET',
                        url: `${hp.getApiBaseUrl()}/auth/password-reset-requests/${token}/tokens/${v.token}`,
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json'
                        }
                    }).then(response => {
                        this.setState({ reseting: false });
                        const res = response.data;
                        if (res.statusCode === 200) {
                            this.setState({ validx: true });
                        } else {
                            notification.error({ message: res.message });
                        }
                    }).catch((err) => {
                        const res = JSON.parse((err.request || '').response);
                        this.setState({ reseting: false, validx: false });
                        notification.error({ message: res.message });

                    });
                }
            });
        }
    }
    _changePwd = (e) => {
        e.preventDefault();
        const { form: { validateFields }, _utils: { lang } } = this.props;
        validateFields((err, data) => {
            if (!err) {
                this.setState({ reseting: true });
                axios({
                    method: 'PUT',
                    url: `${hp.getApiBaseUrl()}/auth/password-resets/${this.state.token}`,
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json'
                    },
                    data
                }).then(response => {
                    this.setState({ reseting: false });
                    const res = response.data;
                    if (res.statusCode === 200) {
                        notification.success({
                            message: this.props.intl.formatMessage(cw['Success']),
                            description: this.props.intl.formatMessage(cw['ChangePassword.Success'])
                        });
                        setTimeout(() => {
                            window.location.assign(`/${lang || 'en'}/signin${window.location.search}`);
                        }, 400);
                    } else {
                        notification.error({
                            message: this.props.intl.formatMessage(cw['Failed']),
                            description: this.props.intl.formatMessage(cw['ChangePassword.Failed'])
                        });
                    }
                }).catch(() => {
                    // const res = JSON.parse((err.request || '').response);
                    this.setState({ reseting: false });
                    notification.error({
                        message: this.props.intl.formatMessage(cw['Failed']),
                        description: this.props.intl.formatMessage(cw['ChangePassword.Failed'])
                    });
                });
            }
        });
    }


    render() {
        const { token, reseting, validx } = this.state;
        const { form: { getFieldDecorator, getFieldValue }, _utils, _auth: { authenticated } } = this.props;

        if (authenticated) {
            return null;
        }

        return (
            <React.Fragment>

                {/* ::: reset */}
                {!token && (
                    <Form id="esoko__signin" hideRequiredMark={true} onSubmit={this._reset}>
                        <img src={Esoko} alt="Esoko" />
                        <div style={{ fontWeight: '400', fontSize: 14, marginTop: 15, marginBottom: 40 }}><FormattedMessage id="auth_reset_title" defaultMessage="Reset your password" /></div>
                        <p className="auth_form_description info">
                            <FormattedMessage id="Reset.Title" defaultMessage="Initiate password reset process by providing your email address below" />
                        </p>

                        <Row gutter={16}>
                            <Col span={24}>
                                <div>
                                    <Form.Item colon={false} label={<FormattedMessage id="Label.EmailAddress" defaultMessage="Email Address" />}>
                                        {getFieldDecorator('userName', {
                                            rules: [
                                                { trigger: 'onChange', required: true, message: <FormattedMessage id="Rules.EmailAddress.Required" defaultMessage="Please provide email address" /> },
                                                { trigger: 'onBlur', validator: this.asyncEmail }
                                            ]
                                        })(
                                            <Input size="large" type="text" autoComplete="off" autoFocus placeholder="you@domain.com" sso-id="reset-email" />
                                        )}
                                    </Form.Item>
                                </div>
                            </Col>
                        </Row>
                        <Form.Item>
                            <Button className="submitBtn" block size="large" type="primary" htmlType="submit" disabled={!getFieldValue('userName')} loading={reseting} sso-id="reset-button">
                                <FormattedMessage id="Button.Reset" defaultMessage="Reset Password" />
                            </Button>
                        </Form.Item>

                        <div className="formLinks">
                            <p style={{ paddingTop: '5%' }}>
                                <span className="noAccountText"><FormattedMessage id="Button.AlreadyHaveAccount" defaultMessage="Already have an account?" /></span>
                                <Link to={`/${_utils.lang || 'en'}/signin${window.location.search}`} sso-id="login-link"><FormattedMessage id="Button.SignIn" defaultMessage="Sign in" /></Link>
                            </p>
                        </div>
                    </Form>
                )}

                {token && !validx && (
                    <Form id="esoko__signin" onSubmit={this.verifyResetToken} className="resetPassword" hideRequiredMark>
                        <img src={Esoko} alt="Esoko" />
                        <div style={{ fontWeight: '400', fontSize: 14, marginTop: 15, marginBottom: 40 }}><FormattedMessage id="auth_reset_verify_title" defaultMessage="Enter verification code" /></div>
                        <p className="auth_form_description warning">
                            <FormattedMessage id="Reset.Reset.Title" defaultMessage="A 6-digit code was sent to your email address. Enter the code you received below" />
                        </p>

                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item colon={false} label={<FormattedMessage id="loginForm.VerificationCode" defaultMessage="Verification code" />}>
                                    {getFieldDecorator('token', {
                                        rules: [
                                            { required: true, message: <FormattedMessage id="Rules.VerificationCode.Required" defaultMessage="Please provide verification code" /> }
                                        ]
                                    })(
                                        <Input size="large" type="text" placeholder="******" sso-id="reset-token" />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        <div style={{ marginTop: '.7rem', marginBottom: '1rem' }}>
                            <Button block type="primary" size="large" htmlType="submit" className="submitBtn" loading={reseting} disabled={!getFieldValue('token')} sso-id="reset-confirm-button">
                                <FormattedMessage id="resetPassword.Confirm" defaultMessage="Confirm" />
                            </Button>
                        </div>
                        <div className="formLinks">
                            <p style={{ paddingTop: '5%' }}>
                                <span className="noAccountText"><FormattedMessage id="Button.AlreadyHaveAccount" defaultMessage="Already have an account?" /></span>
                                <Link to={`/${_utils.lang || 'en'}/signin${window.location.search}`} sso-id="login-link"><FormattedMessage id="Button.SignIn" defaultMessage="Sign in" /></Link>
                            </p>
                        </div>
                    </Form>
                )}

                {token && validx && (
                    <Form id="esoko__signin" onSubmit={this._changePwd} className="resetPassword" hideRequiredMark>
                        <img src={Esoko} alt="Esoko" />
                        <div style={{ fontWeight: '400', fontSize: 14, marginTop: 15, marginBottom: 40 }}><FormattedMessage id="auth_reset_change_password" defaultMessage="Change your password" /></div>
                        <p className="auth_form_description info">
                            <FormattedMessage id="Reset.Reset.Confirm.Title" defaultMessage="Provide your password bellow" />
                        </p>

                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item colon={false} label={<FormattedMessage id="Label.NewPassword" defaultMessage={'New Password'} />}>
                                    {getFieldDecorator('password', {
                                        rules: [
                                            { required: true, message: <FormattedMessage id="Rules.Password.Required" defaultMessage="Please provide password" /> },
                                            { min: 6, message: <FormattedMessage id="Rules.Password.Min6" defaultMessage="Password must be at least 6 characters" /> }
                                        ]
                                    })(
                                        <Input size="large" type="password" placeholder="******" sso-id="reset-password" />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item colon={false} label={<FormattedMessage id="Label.ConfirmPassword" defaultMessage={'Confirm Password'} />}>
                                    {getFieldDecorator('confirmPassword', {
                                        rules: [
                                            { required: true, message: <FormattedMessage id="Rules.Password.Required" defaultMessage="Please provide password" /> },
                                            { validator: this.confirmPasswordMatch },
                                            { min: 6, message: <FormattedMessage id="Rules.Password.Min6" defaultMessage="Password must be at least 6 characters" /> }
                                        ]
                                    })(
                                        <Input size="large" type="password" placeholder="******" sso-id="reset-confirm-password" />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        <div style={{ marginTop: '.7rem', marginBottom: '1rem' }}>
                            <Button block type="primary" size="large" htmlType="submit" className="submitBtn" loading={reseting} sso-id="reset-change-button">
                                <FormattedMessage id="resetPassword.ChangePassword" defaultMessage="Change Password" />
                            </Button>
                        </div>
                    </Form>
                )}

            </React.Fragment>
        );
    }
}

const ResetForm = Form.create({ name: 'reset' })(Reset);
export default ResetForm;